






































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseVue from "../../core/BaseVue";
import Porposal from "../../models/porposal/porposal.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BudgetExpenseService from "@/services/budgetExpense.service";
import BudgetExecutionService from "@/services/budgetExecution.service";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import ProposalBudgetItemExecution from "@/models/porposal/proposalBudgetItemExecution.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import { Utils } from "@/core/Utils";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { ProposalState } from "../../enums/ProposalState";
import ProposalUserReport from '@/models/porposal/porposalUserReport.model';

@Component({
  components: {
    DatePickerComponent
  }
})
export default class BudgetExecution extends GenericBTable<
  ProposalUserReport
> {
  @Prop() public value!: Porposal;

  model: Porposal = this.value || new Porposal();
  budgetExpenseService = new BudgetExpenseService();
  budgetExecutionService = new BudgetExecutionService();
  budgetExpenses = [];
  addMode: boolean = false;
  viewMode: boolean = false;

  currentModel = new ProposalUserReport();
  currentViewModel = new ProposalUserReport();
  repository!: BaseRepository<ProposalUserReport>;
  loading: boolean = false;

  createdState: ProposalState = ProposalState.Creado;
  returnedState: ProposalState = ProposalState.DevueltoCI;

  @Watch("value", { immediate: true, deep: true })
  onValueChange() {
    this.model = this.value || new Porposal();
    this.currentModelChange();
  }

  currentModelChange() {
    for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
      const porposalBudgetItem = this.model.porposalBudgetItems[i];
      var proposalBudgetItemExecution = new ProposalBudgetItemExecution();
      proposalBudgetItemExecution.porposalBudgetItemId = porposalBudgetItem.id;
      proposalBudgetItemExecution.porposalBudgetItem = porposalBudgetItem;

      this.currentModel.proposalBudgetItemsExecution.push(
        proposalBudgetItemExecution
      );
    }
  }

  created() {
    this.repository = new BaseRepository<ProposalUserReport>(
      "ProposalBudgetExecution"
    );
    this.tableConfig.controller = "ProposalBudgetExecution";
    this.tableConfig.whereParams = "PorposalId eq " + this.model.id;
    //this.tableConfig.activeActions = true;
    this.formatColumns();
    this.getBudgetExpenses();
  }

  formatColumns() {
    let title = new BTableColumn("order", "table.title", true);
    let startPeriod = new BTableColumn(
      "startPeriod",
      "table.startPeriod",
      true
    );
    let endPeriod = new BTableColumn("endPeriod", "table.endPeriod", true);
    let totalAmountSpent = new BTableColumn(
      "totalAmountSpent",
      "table.totalAmountSpent",
      true
    );

    title.customTemplate = true;
    startPeriod.customTemplate = true;
    endPeriod.customTemplate = true;
    totalAmountSpent.customTemplate = true;

    this.tableConfig.insertColumns(
      title,
      startPeriod,
      endPeriod,
      totalAmountSpent
    );

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response.filter(x =>
          this.model.porposalBudgetItems.some(y => y.budgetExpenseId == x.id)
        );
      }
    });
  }

  cleanObject(sendObject: ProposalUserReport) {
    this.currentModel.proposalBudgetItemsExecution;

    for (
      let i = 0;
      i < this.currentModel.proposalBudgetItemsExecution.length;
      i++
    ) {
      const item = this.currentModel.proposalBudgetItemsExecution[i];
      item.porposalBudgetItem = null;
    }
  }

  async add() {
    try {
      var valid = await this.$validator.validateAll();
      if (valid) {
        var sendObject = Utils.mapToObject(
          this.currentModel,
          new ProposalUserReport()
        ) as ProposalUserReport;
        sendObject.porposalId = this.model.id;

        this.cleanObject(sendObject);
        this.loading = true;
        let result = await this.repository.create(sendObject);
        this.loading = false;
        this.addMode = false;
        this.tableConfig.reload();
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }

  get totalSpent() {
    return this.currentModel.proposalBudgetItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  get totalCurrentViewSpent() {
    return this.currentViewModel.proposalBudgetItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  async sendToIES(row: ProposalUserReport) {
    
    this.loading = true;
    await this.budgetExecutionService.makeMovementByState(
      row.id,
      ProposalState.EnviadoCI
    );
    this.loading = false;
    this.operationSuccess("Se ha enviado su informe de manera exitosa");
    this.tableConfig.reload();
  }

  viewBudgetExecution(row: ProposalUserReport) {
    this.viewMode = true;
    this.currentViewModel = row;
  }
}
